module.exports = __webpack_public_path__ + "static/media/notification.5343017c.png";